import { render, staticRenderFns } from "./HtmlMaterial.vue?vue&type=template&id=3f70b85c&scoped=true&"
import script from "./HtmlMaterial.vue?vue&type=script&lang=js&"
export * from "./HtmlMaterial.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/html_material.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "@/assets/css/pc/html_printing.css?vue&type=style&index=1&id=3f70b85c&prod&scoped=true&lang=css&"
import style2 from "@/assets/css/sp/html_material.css?vue&type=style&index=2&id=3f70b85c&prod&scoped=true&lang=css&"
import style3 from "./HtmlMaterial.vue?vue&type=style&index=3&id=3f70b85c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f70b85c",
  null
  
)

export default component.exports